export enum PAYCHEX_SSO_ERROR {
    CONNECTION_ERROR = 'CONNECTION_ERROR',
    EXISTING_USER_ERROR = 'EXISTING_USER_ERROR',
}

export enum PAYCHEX_SSO_FLOW_TYPE {
    SIGNUP_NEW_USER = 'SIGNUP_NEW_USER',
    SIGNUP_EXISTING_USER = 'SIGNUP_EXISTING_USER',
    BOX_AD = 'BOX_AD',
    ORGANIC_SIGNUP = 'ORGANIC_SIGNUP',
}

export type PAYCHEX_SSO_FLOW_CONFIG = {
    introScreen?: boolean;
    successPath: string;
    employerInfoPage: {
        title: string;
        subtitle: string;
        buttonText: string;
    };
    successScreen?: {
        subHeader: string;
        title: string;
        subtitle: string;
        footerButtons: {
            text: string;
            href: string;
            action: 'primary' | 'link';
        }[];
    };
};
